var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"go-live-first-container"},[(this.imgflag.startsWith('true'))?_c('img',{staticClass:"go-live-img",attrs:{"width":"18","height":"20","src":"/assets/img/GoLiveImageNew.png","alt":"PDF icon"}}):_vm._e()]),_c('div',{staticClass:"go-live-container",domProps:{"innerHTML":_vm._s(_vm.splashmsg)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }